module.exports = __webpack_public_path__ + "img/kuang.57f5b82f.png";